<template>
  <dependants-import-wizard-component v-if="selectedPlan !== null && selectedPlan !== undefined" @finish="bulkImportFinished()" @close="$router.push({name:'members'})">
  </dependants-import-wizard-component>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DependantsImportWizardComponent from "../components/DependantsImportWizardComponent";
import { planSetter } from "../mixins/planSetter";
  export default {
    name: "dependants-import-wizard",
    components: {
      DependantsImportWizardComponent
    },
    mixins: [planSetter],
    computed: {
      ...mapGetters("common", { selectedPlan: "plan" }),
    },
    methods:{
      bulkImportFinished() {
        this.$router.push({name:'members', params: { planId: this.selectedPlan.Id }})
      }
    }
  }
</script>